import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ConnectionStatus = () => {
  const [toastId, setToastId] = useState(null);

  useEffect(() => {
    function handleConnectionChange() {
      const condition = navigator.onLine ? "online" : "offline";
      // toast(`You are now ${condition}`, { type: condition });

      if (condition === "online") {
        document.body.classList.remove("disable-interaction");
        toast.dismiss(toastId);
        toast("You are now online", { type: "success" });
      }

      if (condition === "offline") {
        document.body.classList.add("disable-interaction");
        const id = toast("You are now offline", {
          autoClose: false,
          closeButton: false,
          type: "error",
        });
        setToastId(id);
      }
    }

    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);

    return () => {
      window.removeEventListener("online", handleConnectionChange);
      window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);

  return <ToastContainer />;
};

export default ConnectionStatus;
